import { render, staticRenderFns } from "./OpenServiceItem.vue?vue&type=template&id=254a9f7a&scoped=true&"
import script from "./OpenServiceItem.vue?vue&type=script&lang=ts&"
export * from "./OpenServiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./OpenServiceItem.vue?vue&type=style&index=0&id=254a9f7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254a9f7a",
  null
  
)

export default component.exports